import React, { Component } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import 'react-datepicker/dist/react-datepicker.css';
import { Redirect, Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupAnioAcademicos } from '../AnioAcademico/LookupAnioAcademicos';

registerLocale('es', es);

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class AddPeriodoExamen extends Component {
  static displayName = AddPeriodoExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      descripcion: '',
      errorMessage: '',
      redirect: false,
      showLookupAnios: false,
      anio: { codigo: '', descripcion: '' },
      llamadoAnterior: 0,
      startDate: new Date(),
      endDate: new Date(),
      llamado: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWPeriodoExamen');
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleShowAniosLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupAnios: true });
    }
  };

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  };

  handleDescripcionChangeInput = (e) => {
    this.clearFeedback();
    this.setState({ descripcion: e.target.value });
  };

  handleLlamadoAnteriorInput = (e) => {
    this.clearFeedback();
    this.setState({ llamadoAnterior: e.target.value });
  };

  handleLlamadoChangeInput = (e) => {
    this.clearFeedback();
    this.setState({ llamado: e.target.value });
  };

  handleSelectAnioItem = (e) => {
    const carreraProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupCarreras: false,
      anio: {
        codigo: carreraProperties[0],
        descripcion: carreraProperties[1],
      },
    });
  };

  handleStartDate = (date) => {
    this.clearFeedback();
    this.setState({ startDate: date });
  };

  handleEndDate = (date) => {
    this.clearFeedback();
    this.setState({ endDate: date });
  };

  isOkToSave() {
    return (
      this.state.descripcion.length > 0
      && this.state.llamado.length > 0
      && this.state.anio.descripcion.length > 1
      && this.state.startDate != null
      && this.state.endDate != null
    );
  }

  areDatesOk() {
    const startDate = new Date(this.state.startDate);
    const endDate = new Date(this.state.endDate);
    return endDate > startDate;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;

    let errorMessage = '';
    const datesOk = this.areDatesOk();
    const isOkToSave = this.isOkToSave();

    if (!isOkToSave) {
      errorMessage = 'Todos los campos son obligatorios';
    }

    if (!datesOk) {
      if (errorMessage.length > 0) {
        errorMessage = errorMessage + ', la fecha de inicio no puede ser posterior a la fecha de fin';
      } else {
        errorMessage = 'La fecha de inicio no puede ser posterior a la fecha de fin';
      }
    }

    if (isOkToSave && datesOk) {
      this.saveStudent();
    } else {
      this.setState({ errorMessage });
    }
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/pex', {
      method: 'POST',
      body: JSON.stringify({
        PeriodoExamenDescripcion: this.state.descripcion,
        PeriodoExamenLlamado: this.state.llamado,
        PeriodoExamenFechaInicio: constantClass.serializeDateForApi(this.state.startDate),
        PeriodoExamenFechaFin: constantClass.serializeDateForApi(this.state.endDate),
        AnioAcademicoCod: this.state.anio.codigo,
        PeriodoExamenPrimerLlamado: this.state.llamadoAnterior,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo guardar el período de examen. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-pex" />;
    }

    const {
      loading,
      errorMessage,
      descripcion,
      llamado,
      anio,
      startDate,
      endDate,
      llamadoAnterior,
      showLookupAnios,
    } = this.state;
    const isBusy = loading;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-pex">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Nuevo Período de Examen</h1>
        <p className="md-form-page__subtitle">
          Complete los datos del período, el llamado, el año académico y las fechas de vigencia.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando período de examen, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="pex-descripcion">
                Período de Examen
              </label>
              <input
                id="pex-descripcion"
                className="md-form-page__input"
                type="text"
                value={descripcion}
                placeholder="Ingrese período de examen"
                onChange={this.handleDescripcionChangeInput}
                disabled={isBusy}
                required
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="pex-llamado">
                Llamado
              </label>
              <input
                id="pex-llamado"
                className="md-form-page__input"
                type="text"
                value={llamado}
                placeholder="Ingrese llamado"
                onChange={this.handleLlamadoChangeInput}
                disabled={isBusy}
                required
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Año Académico</span>
              <button
                type="button"
                className="md-form-page__pick-btn"
                onClick={this.handleShowAniosLookup}
                disabled={isBusy}
              >
                Seleccione el Año Académico
              </button>
              {showLookupAnios ? (
                <LookupAnioAcademicos
                  selectItem={this.handleSelectAnioItem}
                  hideLookup={this.handleHideLookup}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={anio.descripcion}
                placeholder="Año académico seleccionado"
                readOnly
                disabled
                aria-label="Año académico"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="pex-fecha-inicio">
                Fecha de Inicio
              </label>
              <DatePicker
                id="pex-fecha-inicio"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={startDate}
                onChange={this.handleStartDate}
                disabled={isBusy}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="pex-fecha-fin">
                Fecha de Fin
              </label>
              <DatePicker
                id="pex-fecha-fin"
                className="md-form-page__input"
                locale="es"
                closeOnScroll
                selected={endDate}
                onChange={this.handleEndDate}
                disabled={isBusy}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="pex-llamado-anterior">
                Llamado Anterior
              </label>
              <input
                id="pex-llamado-anterior"
                className="md-form-page__input"
                type="text"
                value={llamadoAnterior}
                placeholder="Ingrese el código del llamado anterior o 0"
                onChange={this.handleLlamadoAnteriorInput}
                disabled={isBusy}
                required
              />
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
